/**
 * Created by Dinkic on 3/7/2018.
 */
// SERVICES
import Http from '../services/Http';

//public sector
export default class Repo {

    constructor($auth, resource){
        this.http = new Http($auth);
        this.resource = resource;
    }

    store(data, include = ""){
        return this.http.post(this.resource + "?include=" + include, data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    update(id, data, include = ""){
        return this.http.put(this.resource + "/" + id + "?include=" + include, data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    get(id, include = ""){
        return this.http.get(this.resource + "/" + id + "?include=").then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    all(q = undefined, include = ""){
        let url = this.resource  + "?include=" + include;

        if(q !== undefined){
            url = url + "&q="+q;
        }
        return this.http.get(url).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    delete(id){
        return this.http.delete(this.resource + "/" + id).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    search(data, include = ""){
        return this.http.post(this.resource + "/search" + "?include=" + include, data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    paginate(data){
        return this.http.post(this.resource + "/paginate", data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

}



// WEBPACK FOOTER //
// ./src/repos/Repo.js